export enum ModuleTypes {
  Home = '',
  Dining = 'dining',
  Entertainment = 'entertainment',
  Inspiration = 'inspiration',
  MemberBenefits = 'member-benefits',
  MemberEvent = 'member-event',
  Partners = 'partners',
  Preferences = 'preferences',
  Travel = 'travel',
  MemberEvents = 'member-events',
}

export enum ContentOutsideLoginTypes {
  Homepage = 'homepage',
  Benefits = 'benefits',
  Inspiration = 'inspiration',
}

export enum ContentOutsideFeatureTypes {
  Travel = 'TRAVEL',
  Entertainment = 'ENTERTAINMENT',
  Dining = 'DINING',
  Shopping = 'SHOPPING',
  Benefits = 'Benefits Page',
  Combined = 'COMBINED',
}
